<template>
  <div class="navigation-item w-full flex items-center overflow-hidden cursor-pointer relative select-none" :class="{ 'bg-primary-selected': selected }" @click="$emit('click', $event)">
    <div class="w-18 h-16 flex justify-center items-center flex-shrink-0" v-tooltip.right="{ content: text, disabled: open }">
      <Icon :name="icon" class="w-7 h-7 text-[rgb(var(--color-menu-text))] flex items-center justify-center" :class="{ 'opacity-70': !selected, [iconClass]: true }" />
    </div>
    <span v-if="text" class="text-[rgb(var(--color-menu-text))] text-16 whitespace-nowrap overflow-hidden">{{ text }}</span>
    <div v-if="selected" class="selected-indicator absolute w-2 h-18 bg-[rgb(var(--color-menu-selected-border))] rounded-l-6" style="right: -5px"></div>
  </div>
</template>

<script>
export default {
  name: 'NavigationItem',
  props: {
    text: String,
    icon: String,
    iconClass: String,
    selected: Boolean,
    open: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
};
</script>
<style lang="scss"></style>
